import { render } from "./404Component.vue?vue&type=template&id=f7cb8442"
import script from "./404Component.vue?vue&type=script&lang=js"
export * from "./404Component.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__